import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgVideos = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ jsxs("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props, children: [
  title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
  /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 0.499481H14C15.1035 0.499481 16 1.39633 16 2.49948V14.4995C16 15.6026 15.1035 16.4995 14 16.4995H2C0.896484 16.4995 0 15.6026 0 14.4995V2.49948C0 1.39633 0.896484 0.499481 2 0.499481ZM11 8.49948L6 5.49948V11.4995L11 8.49948Z" })
] });
const ForwardRef = /* @__PURE__ */ forwardRef(SvgVideos);
export { ForwardRef as ReactComponent };
import assetUrl from "/home/runner/work/UpstriveEducation-Teacher/UpstriveEducation-Teacher/src/assets/svg/videos.svg?url";
export default assetUrl;
